module.exports = __webpack_public_path__ + "fd70514962fcf5a59cc9f5aa98b0686f.png";